import { FormControl } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { MonitorUrlFieldInput } from 'components/status-checks/form/status-check/common/MonitorUrlFieldInput'
import { useGetExistingStatusCheckByMonitorUrl } from 'components/status-checks/hooks/use-get-existing-status-check-by-monitor-url'
import {
  type StatusCheckFormValues,
  StatusCheckMonitorSelectionRadioValue
} from 'components/status-checks/status-checks-form-utils'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'

const fieldsToWatch = [
  'externalIntegration',
  'observabilityTool',
  'monitorUrl'
] as const

export const DatadogMonitorURL: React.FC<{
  radioValue: StatusCheckMonitorSelectionRadioValue
}> = ({ radioValue }) => {
  const { control } = useFormContext<StatusCheckFormValues>()
  const [externalIntegration, observabilityTool, monitorUrl] = useWatch<
    StatusCheckFormValues,
    typeof fieldsToWatch
  >({ control, name: fieldsToWatch })

  const statusChecksUrls = getStatusChecksUrls()
  const existingStatusCheck = useGetExistingStatusCheckByMonitorUrl(
    observabilityTool,
    monitorUrl
  )

  return (
    <FormControl>
      <Controller
        control={control}
        name="monitorUrl"
        render={({ field, fieldState }) => (
          <MonitorUrlFieldInput
            disabled={radioValue !== StatusCheckMonitorSelectionRadioValue.URL}
            externalIntegration={externalIntegration}
            field={field}
            fieldState={fieldState}
            {...(existingStatusCheck?.id && {
              to: statusChecksUrls.edit(existingStatusCheck.id)
            })}
          />
        )}
      />
    </FormControl>
  )
}
